import { isNil, isNull } from 'lodash-es'
import { ComponentProps } from 'react'

import { WeeklyCalendar } from '@/entities/contract'
import { useFormatDate } from '@/shared/lib'

import { useRoomAvailableWeeks } from '../api/get-room-available-weeks'

type Props = Omit<
  ComponentProps<typeof WeeklyCalendar>,
  'roomAvailableWeeks' | 'startDate'
> & {
  startDate?: Date
  roomId: number
  isExtend?: boolean
}

export const AvailableWeekCalendar = ({
  startDate,
  endDate,
  roomId,
  isExtend = false,
  ...restProps
}: Props) => {
  const { formatDate } = useFormatDate()

  const { roomAvailableWeeks } = useRoomAvailableWeeks({
    roomId,
    startDate: formatDate({
      date: startDate,
      format: 'yyyy-MM-dd',
    }),
    isExtend,
    enabled: !isNil(startDate),
  })

  return (
    <WeeklyCalendar
      startDate={startDate}
      endDate={endDate}
      showCloseButton={false}
      isExtend={isExtend}
      {...(!isNull(roomAvailableWeeks) && {
        availableWeeks: roomAvailableWeeks,
      })}
      {...restProps}
    />
  )
}
